import React, {useEffect, useRef, useState} from 'react';
import {Modal} from 'react-bootstrap';
import OeTip from './OeTip';

/**
 * Rückfrage mit Mengeneingabe — Ersatz für die beiden Overlay-Varianten des
 * Originals mit Zahlenfeld: „Bestand korrigieren" (`openStockCorrectModal`,
 * 3803) und „Fertige Sets am Lager korrigieren" (`askSetCorrect`, 2426).
 * ABGLEICH F3, F5.
 *
 * Browsereigene Dialoge sind im Haus nicht zugelassen; die Untergrenze wird
 * hier hart durchgesetzt, damit andere offene Aufträge gedeckt bleiben.
 *
 * @param {object} dialog - {title, hint, item, label, unit, value, min, max, preview, confirmLabel, tone}
 */
export default function QuantityDialog({dialog, busy, onConfirm, onCancel}) {
    const [wert, setWert] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (dialog) {
            setWert(String(dialog.value ?? ''));
            window.setTimeout(() => {
                inputRef.current?.focus();
                inputRef.current?.select();
            }, 30);
        }
    }, [dialog]);

    if (!dialog) {
        return null;
    }

    const zahl = Math.floor(parseFloat(String(wert).replace(',', '.')) || 0);
    const gueltig = Number.isFinite(zahl) && zahl >= (dialog.min ?? 0) && (dialog.max == null || zahl <= dialog.max);

    return (
        <Modal show onHide={onCancel} centered backdrop="static" aria-labelledby="oe-qty-title">
            <Modal.Header closeButton>
                <Modal.Title id="oe-qty-title" style={{fontSize: 16}}>{dialog.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{fontSize: 14, lineHeight: 1.5}}>
                <div>{dialog.hint}</div>
                {dialog.item ? <div className="neu" style={{marginTop: 8}}>{dialog.item}</div> : null}
                <div style={{display: 'flex', alignItems: 'center', gap: 10, marginTop: 10}}>
                    {dialog.label ? <span className="muted">{dialog.label}</span> : null}
                    <OeTip tip={dialog.inputTip || 'Menge eingeben.'}>
                        <input
                            ref={inputRef}
                            className="rngi"
                            style={{width: 110}}
                            value={wert}
                            inputMode="numeric"
                            autoComplete="off"
                            aria-label={dialog.label || 'Menge'}
                            onChange={(e) => setWert(e.target.value)}
                        />
                    </OeTip>
                    {dialog.unit ? <span className="muted">{dialog.unit}</span> : null}
                    {dialog.preview ? <span className="muted">{dialog.preview(zahl)}</span> : null}
                </div>
                {!gueltig ? (
                    <div className="status err" style={{marginTop: 8}}>
                        Bitte eine Menge zwischen {dialog.min ?? 0}
                        {dialog.max != null ? ` und ${dialog.max}` : ''} eingeben.
                    </div>
                ) : null}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy} onClick={onCancel}>
                    Abbrechen
                </button>
                <button
                    type="button"
                    className={`btn btn-sm ${dialog.tone === 'danger' ? 'btn-danger' : 'btn-weclapp'}`}
                    disabled={busy || !gueltig}
                    onClick={() => onConfirm(zahl)}
                >
                    {busy ? 'läuft…' : (dialog.confirmLabel || 'Übernehmen')}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
